<template>
  <div class="test pad-10">
    <template v-if="_show">

      <h1 class="title is-4">JOB HOURS</h1>
      <div class="buttons">
        <button class="button" @click="deleteNoJobNums()">Delete no job nums</button>
        <button class="button" @click="deleteNoHours()">Delete no hours</button>
        <button class="button" @click="deleteDupeHours()">Delete dupe hours</button>
        <button class="button" @click="deleteDupeDiffHours()">Delete dupe dif hours</button>
        <button class="button" @click="fixTimeEntries()">Fix time entries with no hour entries</button>
        <button class="button" @click="fixHours()">Fix hours with no time entries</button>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th></th>
            <th></th>
            <th>entryId</th>
            <th>job #</th>
            <th>mins</th>
            <th>date</th>
            <th>user</th>
            <th>hour._Id</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(h, i) in hours" :key="h._id">
            <td>{{ i + 1}}</td>
            <th>{{ h.type }}</th>
            <th>{{ h.timeEntryId }}</th>
            <td>{{ h.jobNumber }}</td>
            <td>{{ h.hours }}</td>
            <td>{{ h.date | formatDate}}</td>
            <td>{{ h.frstName }} {{ h.lastName }}</td>
            <th>{{ h._id }}</th>
          </tr>
        </tbody>
      </table>

    </template>
  </div>
</template>

<script>
export default {
  components: {
  },
  data () {
    return {
      users: null,
      testDoc: null,
      hours: []
    }
  },
  computed: {
    _show () { return document.location.hostname === 'localhost' }
  },
  created () {
    this.$firestore.collection('hours')
      .where('timeEntryId', '>', '0')
      .orderBy('timeEntryId')
      .onSnapshot(snapshot => {
        this.hours = this.snapshotToHours(snapshot)
      })
  },
  methods: {
    snapshotToHours (snapshot) {
      let data = this.$utils.snapshotToArr(snapshot)
      let hours = []
      let timeEntryId = null
      let lastH = null
      let count = 0
      for (let h of data) {
        if (h.timeEntryId === timeEntryId) {
          if (!count) {
            lastH.type = 'FIRST'
            lastH.first = true
            hours.push(lastH)
          }
          count++
          h.type = 'COPY ' + count
          h.copy = true
          hours.push(h)
        } else {
          count = 0
        }
        timeEntryId = h.timeEntryId
        lastH = h
      }
      return hours
    },
    async fixHours () {
      let ss = await this.$firestore.collection('timeEntries')
        .where('jobNumber', '>', 0)
        .get()
      let timeEntries = this.$utils.snapshotToArr(ss)
      console.log(`${timeEntries.length} timeEntries`)

      let ss2 = await this.$firestore.collection('hours')
        .where('timeEntryId', '>', '0')
        .get()
      let hours = this.$utils.snapshotToArr(ss2)
      console.log(`${hours.length} hours`)

      let count = 0
      for (let h of hours) {
        let i = timeEntries.findIndex(te => te._id === h.timeEntryId)
        if (i < 0) {
          count++
          console.log(`${count} no timeEntry`, h)
          this.$firestore.collection('hours').doc(h._id).delete()
        }
      }
      console.log(`${count} hours with no entries`)
    },
    async fixTimeEntries () {
      let ss = await this.$firestore.collection('timeEntries')
        .where('endTimestamp', '>', 0)
        .get()
      let timeEntries = this.$utils.snapshotToArr(ss)
      console.log(`${timeEntries.length} timeEntreis`)
      ss = await this.$firestore.collection('hours').get()
      let hours = this.$utils.snapshotToArr(ss)
      console.log(`${hours.length} hours`)
      let count = 0
      for (let te of timeEntries) {
        if (!te.jobNumber) {
          continue
        }
        let i = hours.findIndex(h => h.timeEntryId === te._id)
        if (i < 0) {
          count++
          console.log(`${count} no hours`, te)
        }
      }
      console.log(`${count} entries with no hours`)
    },
    async deleteDupeDiffHours () {
      let snapshot = await this.$firestore.collection('hours')
        .where('timeEntryId', '>', '0')
        .orderBy('timeEntryId')
        .get()
      let hours = this.snapshotToHours(snapshot)
      let count = 0
      let noExistCount = 0
      let lastH = null
      for (let h of hours) {
        if (lastH && lastH.first && h.copy && lastH.timeEntryId === h.timeEntryId && h.hours !== lastH.hours) {
          let ss = await this.$firestore.collection('timeEntries').doc(h.timeEntryId).get()
          let timeEntry = this.$utils.snapshotToObj(ss)
          if (!timeEntry) {
            noExistCount++
            console.warn(noExistCount, `time entry ${h.timeEntryId} does not exist`)
            continue
          }
          let timeEntryHours = timeEntry.duration / 3600
          if (timeEntryHours !== lastH.hours) {
            count++
            console.log(`${count} delete lastH`, lastH)
            // this.$firestore.collection('hours').doc(lastH._id).delete()
          } else if (timeEntryHours !== h.hours) {
            count++
            console.log(`${count} delete h`, h)
            // this.$firestore.collection('hours').doc(h._id).delete()
          } else {
            console.warn(`should not get here ${h.timeEntryId}`)
          }
        }
        lastH = h
      }
    },
    async deleteDupeHours () {
      let snapshot = await this.$firestore.collection('hours')
        .where('timeEntryId', '>', '0')
        .orderBy('timeEntryId')
        .get()
      let hours = this.snapshotToHours(snapshot)
      let count = 0
      let lastH = null
      for (let h of hours) {
        if (lastH && lastH.first && h.copy && lastH.timeEntryId === h.timeEntryId && h.hours === lastH.hours) {
          count++
          console.log(count, h)
          // this.$firestore.collection('hours').doc(h._id).delete()
        }
        lastH = h
      }
      console.log(`${count} duplicated hours`)
    },
    async deleteNoHours () {
      let snapshot = await this.$firestore.collection('hours')
        .where('timeEntryId', '>', '0')
        .orderBy('timeEntryId')
        .get()
      let hours = this.$utils.snapshotToArr(snapshot)
      let count = 0
      for (let h of hours) {
        if (!h.hours) {
          count++
          console.log(count, h)
          // this.$firestore.collection('hours').doc(h._id).delete()
        }
      }
      console.log(`${count} hours with no hours`)
    },
    async deleteNoJobNums () {
      let snapshot = await this.$firestore.collection('hours')
        .where('jobNumber', '==', 0)
        .get()
      let hours = this.$utils.snapshotToArr(snapshot)
      let count = 0
      for (let h of hours) {
        if (!h.jobNumber) {
          count++
          console.log(count, h)
          // this.$firestore.collection('hours').doc(h._id).delete()
        }
      }
      console.log(`${count} jobs ith no number`)
    }
  }
}
</script>

<style>
</style>
